import { FC } from 'react';
import { FaCalendarWeek } from 'react-icons/fa';
import { CustomProvider, DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite-no-reset.min.css';
import { DateRange } from 'rsuite/esm/DateRangePicker';
import ptBr from 'rsuite/locales/pt_BR';
import './styles.scss';

interface indexProps {
  placeholder: string;
  setSelectedRangeDate: (value: DateRange | null) => void;
  [x: string]: any;
}

const StyledDateRangeSelect: FC<indexProps> = ({
  placeholder,
  setSelectedRangeDate,
  ...rest
}) => {
  return (
    <CustomProvider locale={ptBr}>
      <DateRangePicker
        {...rest}
        appearance="default"
        placeholder={placeholder}
        onChange={(value) => setSelectedRangeDate(value)}
        caretAs={FaCalendarWeek}
        format="dd-MM-yyyy"
        style={{ width: '100%' }}
        size="lg"
      />
    </CustomProvider>
  );
};

export default StyledDateRangeSelect;
